/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Booking_Times_Syntax_1Inputs */

const en_admin_resource_form_booking_times_syntax_1 = /** @type {(inputs: Admin_Resource_Form_Booking_Times_Syntax_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use commas to enter multiple days of the week and/or times of the day. e.g.:`)
};

const de_admin_resource_form_booking_times_syntax_1 = /** @type {(inputs: Admin_Resource_Form_Booking_Times_Syntax_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um mehrere Zeiten anzugeben, trenne diese mit einem Komma. Z.B.:`)
};

const es_admin_resource_form_booking_times_syntax_1 = /** @type {(inputs: Admin_Resource_Form_Booking_Times_Syntax_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa comas para introducir varios días de la semana y/o horas del día, por ejemplo:`)
};

const fr_admin_resource_form_booking_times_syntax_1 = /** @type {(inputs: Admin_Resource_Form_Booking_Times_Syntax_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisez des virgules pour saisir plusieurs jours de la semaine et/ou plusieurs horaires, par exemple :`)
};

const nl_admin_resource_form_booking_times_syntax_1 = /** @type {(inputs: Admin_Resource_Form_Booking_Times_Syntax_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebruik komma's om meerdere weekdagen en/of tijden in te voeren. Bijv.:`)
};

/** @type {(inputs: Admin_Resource_Form_Booking_Times_Syntax_1Inputs) => LocalizedString} */
const it_admin_resource_form_booking_times_syntax_1 = en_admin_resource_form_booking_times_syntax_1;

/** @type {(inputs: Admin_Resource_Form_Booking_Times_Syntax_1Inputs) => LocalizedString} */
const pt_br2_admin_resource_form_booking_times_syntax_1 = en_admin_resource_form_booking_times_syntax_1;

/** @type {(inputs: Admin_Resource_Form_Booking_Times_Syntax_1Inputs) => LocalizedString} */
const pl_admin_resource_form_booking_times_syntax_1 = en_admin_resource_form_booking_times_syntax_1;

/** @type {(inputs: Admin_Resource_Form_Booking_Times_Syntax_1Inputs) => LocalizedString} */
const hu_admin_resource_form_booking_times_syntax_1 = en_admin_resource_form_booking_times_syntax_1;

/** @type {(inputs: Admin_Resource_Form_Booking_Times_Syntax_1Inputs) => LocalizedString} */
const ro_admin_resource_form_booking_times_syntax_1 = en_admin_resource_form_booking_times_syntax_1;

/**
* | output |
* | --- |
* | "Use commas to enter multiple days of the week and/or times of the day. e.g.:" |
*
* @param {Admin_Resource_Form_Booking_Times_Syntax_1Inputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_booking_times_syntax_1 = /** @type {((inputs?: Admin_Resource_Form_Booking_Times_Syntax_1Inputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Booking_Times_Syntax_1Inputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_booking_times_syntax_1(inputs)
	if (locale === "de") return de_admin_resource_form_booking_times_syntax_1(inputs)
	if (locale === "es") return es_admin_resource_form_booking_times_syntax_1(inputs)
	if (locale === "fr") return fr_admin_resource_form_booking_times_syntax_1(inputs)
	if (locale === "nl") return nl_admin_resource_form_booking_times_syntax_1(inputs)
	if (locale === "it") return it_admin_resource_form_booking_times_syntax_1(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_booking_times_syntax_1(inputs)
	if (locale === "pl") return pl_admin_resource_form_booking_times_syntax_1(inputs)
	if (locale === "hu") return hu_admin_resource_form_booking_times_syntax_1(inputs)
	return ro_admin_resource_form_booking_times_syntax_1(inputs)
});
export { admin_resource_form_booking_times_syntax_1 as "admin.resource_form.booking_times_syntax_1" }